import { TimelineSegmentDataBase, TimelineSegmentContentDataBase } from '../ScattData.js';

function snakeCaseToLowerCamelCase(snakeCaseString) {
  let stringComponents = snakeCaseString.split('_');
  let lowerCamelCase = stringComponents.shift();
  for (let stringComponent of stringComponents) {
    let firstLetter = stringComponent.slice(0, 1).toUpperCase();
    if (stringComponent.length > 0) {
      lowerCamelCase += firstLetter;
      if (stringComponent.length > 1) {
        lowerCamelCase += stringComponent.slice(1);
      }
    }
  }
  return lowerCamelCase;
}

function lowerCamelCaseToSnakeCase(lowerCamelCase) {
  let snakeCase;
  for (let stringComponent of lowerCamelCase.match(/(?:[^A-Z]+|[A-Z][^A-Z]*)/g)) {
    let lowerCaseStringComponent = stringComponent.toLowerCase();
    if (snakeCase === undefined) {
      snakeCase = lowerCaseStringComponent;
    } else {
      snakeCase += `_${lowerCaseStringComponent}`;
    }
  }
  return snakeCase;
}

class GeneralData extends TimelineSegmentContentDataBase {
  constructor(data = {}) {
    super();
    for (let [ key, value ] of Object.entries(data)) {
      this[key] = value;
    }
  }

  static generateFromRawObj(dataRawObj) {
    let data = {};
    for (let [ key, value ] of Object.entries(dataRawObj)) {
      data[snakeCaseToLowerCamelCase(key)] = value;
    }
    return new this(data);
  }

  generateRawObj() {
    let generalDataRawObj = {};
    for (let [ key, value ] of Object.entries(this)) {
      generalDataRawObj[lowerCamelCaseToSnakeCase(key)] = value;
    }
    return generalDataRawObj;
  }

  clone() {
    return new this.constructor(this);
  }

  isSameAs(that) {
    let thisKeys = Object.keys(this);
    let thatKeys = Object.keys(that);
    if (thisKeys.length !== thatKeys.length) return false;
    for (let key of thisKeys) {
      if (!thatKeys.includes(key)) return false;
      if (this[key] !== that[key]) return false;
    }
    return true;
  }

  combine(that) {
    for (let [ key, value ] of Object.entries(that.data)) {
      if (!Object.keys(this.data).includes(key)) this.data[key] = value;
    }
  }
}

class GeneralSegmentData extends TimelineSegmentDataBase {
  static contentData = GeneralData;

  static toString() {
    return 'GeneralSegmentData';
  }

  static get name() {
    return 'General Data';
  }

  clone() {
    return super.clone(false);
  }
}

export default GeneralSegmentData;
